module.exports = __webpack_public_path__ + "img/news_28-04-2021-XmasParty.9c6c79e5.jpg";